import React from 'react';
import { IOrderSummaryItem } from './OrderSummaryItem';
import { Grid, styled, Typography } from '@mui/material';
import { useCurrencyString } from 'lib/hooks/useCurrencyString';

interface RecursiveModifierOptionProps {
    modifiers: IOrderSummaryItem[];
    orderItemQuantity: number;
}

const StyledUL = styled('ul')(({ theme }) => ({
    listStyle: 'none',
    width: '100%',
    paddingLeft: theme.spacing(3)
}));

export const RecursiveModifierOption: React.FC<RecursiveModifierOptionProps> = ({
    modifiers,
    orderItemQuantity
}) => {
    const getCurrencyString = useCurrencyString();
    const modifierTitle = React.useCallback(
        (modifier: IOrderSummaryItem) => {
            const computedQuantity = modifier.quantity / orderItemQuantity;
            const productName =
                computedQuantity > 1 ? `${computedQuantity}x ${modifier.title}` : modifier.title;
            return productName;
        },
        [orderItemQuantity]
    );
    const modifierCost = React.useCallback(
        (modifier: IOrderSummaryItem) => {
            const computedQuantity = modifier.quantity / orderItemQuantity;
            const quantity = computedQuantity > 1 ? computedQuantity : 1;
            return getCurrencyString(modifier.cost * quantity);
        },
        [orderItemQuantity, getCurrencyString]
    );
    return (
        <StyledUL>
            {modifiers.map(modifier => (
                <React.Fragment key={`${modifier.id}`}>
                    <li>
                        <Grid
                            container
                            justifyContent="space-between"
                            spacing={1}
                            sx={{
                                textDecoration: modifier.deleted ? 'line-through' : undefined
                            }}
                        >
                            <Grid size={9}>
                                <Typography variant="body2" sx={{ opacity: 0.7 }}>
                                    {modifierTitle(modifier)}
                                </Typography>
                            </Grid>
                            <Grid size={3}>
                                <Typography sx={{ opacity: 0.7 }} align="right" variant="body2">
                                    {modifierCost(modifier)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </li>
                    <RecursiveModifierOption
                        modifiers={modifier.modifiers}
                        orderItemQuantity={orderItemQuantity}
                    />
                </React.Fragment>
            ))}
        </StyledUL>
    );
};
